








import { Component, Vue } from 'vue-property-decorator';
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import { AppModule } from '@/store/modules/app';
import i18n from './i18n'

@Component({
  components: {
    Header,
    Footer
  }

})
export default class App extends Vue {

  created() {
    window.onbeforeunload = this.onBeforeUnload
    if(this.session && this.session.locale) {
      i18n.locale = this.session.locale
    }
  }

  onBeforeUnload() {
    if(this.isClean) {
      return
    }
    return "Seite verlassen? Alle eingegebenen Daten gehen verloren."
  }

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.onBeforeUnload)
  }

  get isClean() {
    return AppModule.isClean
  }

  get session() {
    return AppModule.session
  }

}
